import React, { useCallback, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import CCLatestCourse from "../pages/Cclatestcourse";
import CourseTwoForThirdParty from "../pages/CourseTwoForThirdParty";
import BudgetAnalysisThirdParty from "../pages/BudgetAnalysisThirdParty";
import BudgetAnalysisSummaryThirdParty from "../pages/BudgetAnalysisSummaryThirdParty";
import { buildApiUrl } from "../../config/api";
import ClientIdentityBadge from "./ClientIdentityBadge";

const CourseAccess = ({ course }) => {
  const { clientId } = useParams();
  const location = useLocation();
  const routeToken = location.state?.token || null;
  const routeClient = location.state?.client || null;

  const [loading, setLoading] = useState(!routeToken || !routeClient);
  const [verified, setVerified] = useState(Boolean(routeToken));
  const [token, setToken] = useState(routeToken);
  const [client, setClient] = useState(routeClient);

 const verifyClient = useCallback(async () => {
  try {
    const response = await fetch(
      buildApiUrl("api/verifyClientId"),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          clientId,
          API_key:process.env.REACT_APP_API_KEY,
        }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "Verification failed");
    }

    console.log("Verify Response:", data);
    setToken(data.token || token);
    setClient(data || {});
    setVerified(true);
  } catch (error) {
    console.error(error);
    setVerified(false);
  } finally {
    setLoading(false);
  }
}, [clientId, token]);

  useEffect(() => {
    if (!token || !client) {
      verifyClient();
    }
  }, [token, client, verifyClient]);

  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "40vh" }}
      >
        <ThreeDots
          height="40"
          width="80"
          radius="9"
          color="#4fa94d"
          ariaLabel="three-dots-loading"
          wrapperStyle={{ display: "flex", justifyContent: "center" }}
          wrapperClassName="spinner"
          visible={true}
        />
      </div>
    );

  if (!verified)
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center text-center"
        style={{ height: "60vh", padding: "1rem" }}
      >
        <div style={{ maxWidth: 480 }}>
          <h3 className="mb-3">Unauthorized Access</h3>
          <p className="mb-4 text-muted">
            You don't have permission to view this course. If you believe this is
            an error, please contact support or check your access link.
          </p>
          {/* <a href="/" className="btn btn-outline-primary">
            Go to Home
          </a> */}
        </div>
      </div>
    );

// read optional query param named `params` and pass it to child components
const externalParams = new URLSearchParams(location.search).get("params");

if (course === "CC") {
  return (
      <CCLatestCourse
        thirdParty={true}
        token={token}
        clientId={clientId}
        params={externalParams}
        client={client}
      />
  );
}

if (course === "CC_BUDGET") {
  return (
    <div className="third-party-budget-layout">
      <ClientIdentityBadge client={client} />
      <BudgetAnalysisThirdParty
        token={token}
        clientId={clientId}
        params={externalParams}
        client={client}
      />
    </div>
  );
}

if (course.startsWith("CC_BUDGET_SUMMARY")) {
  const section = course.replace("CC_BUDGET_SUMMARY_", "").toLowerCase();
  return (
    <>
      <ClientIdentityBadge client={client} />
      <BudgetAnalysisSummaryThirdParty
        section={section}
        token={token}
        clientId={clientId}
        params={externalParams}
        client={client}
      />
    </>
  );
}

if (course === "DE") {
  return (
    <>
      <ClientIdentityBadge client={client} />
      <CourseTwoForThirdParty
        thirdParty={true}
        token={token}
        clientId={clientId}
        params={externalParams}
      />
    </>
  );
}

return null;
};

export default CourseAccess;
